import si, { ImmutableObject } from 'seamless-immutable';
import _ from 'lodash';
import * as ru from '../../../../../../utils/redux';
import { getListState, ListStatuses } from '../../../../../../utils/store/state/state';
import { SupplierAgentListState, ISupplierAgent } from './types';

import * as actions from './actions';
import * as r from '../../../../../../utils/reducers';

interface IState {
  list: SupplierAgentListState;
  item: ISupplierAgent | null;
  itemLoading: boolean;
  itemError: string;
}

const INITIAL_STATE: ImmutableObject<IState> = si({
  // LIST
  list: getListState({
    page: 0,
    size: 20,
    ownerId: null,
  }),
  // ITEM
  item: null,
  itemLoading: false,
  itemError: '',
  // INVITATION
  invitationLoading: false,
  invitationError: '',
});

const listReducer = r.createReducer('list');

export default ru.processActions(
  () => ({
    // LIST
    [actions.GET_SUPPLIER_AGENTS_REQ]: listReducer(r.loadingReducer),
    [actions.GET_SUPPLIER_AGENTS_REQ_SUCCESS]: (store: ImmutableObject<IState>, action: any) => {
      const {
        payload: { data, params },
        meta,
      } = action;
      return store
        .setIn(['list', 'data'], params.page > 0 ? store.list.data.concat(data) : data)
        .setIn(['list', 'status'], ListStatuses.Actual)
        .setIn(['list', 'meta'], meta)
        .setIn(['list', 'params'], params);
    },
    [actions.GET_SUPPLIER_AGENTS_REQ_ERROR]: listReducer(r.errorReducer),
    [actions.SET_SUPPLIER_AGENTS]: listReducer(r.listDataReducer),
    [actions.REFRESH_SUPPLIER_AGENTS]: listReducer(r.refreshReducer),
    [actions.CLEAR_SUPPLIER_AGENTS]: listReducer(r.resetReducer),
    [actions.SET_SUPPLIER_AGENTS_PARAMS]: listReducer(r.paramsReducer),

    // GET SUPPLIER_AGENT
    [actions.SET_SUPPLIER_AGENT]: (store: ImmutableObject<IState>, action: any) => {
      return store.set('item', _.head(action.payload));
    },
    [actions.CLEAR_SUPPLIER_AGENT]: (store: ImmutableObject<IState>, action: any) => {
      return store.set('item', null);
    },

    // UPDATE SUPPLIER_AGENT
    [actions.UPDATE_SUPPLIER_AGENT]: (store: ImmutableObject<IState>, action: any) => {
      return store.set('item', _.head(action.payload));
    },

    // DELETE SUPPLIER_AGENT
    [actions.DELETE_SUPPLIER_AGENT_REQ_SUCCESS]: (store: ImmutableObject<IState>, { payload }: any) => {
      return store.setIn(['list', 'data'], store.list.data.filter((agent) => agent.email !== payload.email));
    },

    // SEND_SUPPLIER_AGENT_INVITATION
    [actions.SEND_SUPPLIER_AGENT_INVITATION_REQ]: (store: ImmutableObject<IState>, action: any) => {
      return store.set('invitationLoading', true);
    },
    [actions.SEND_SUPPLIER_AGENT_INVITATION_SUCCESS]: (store: ImmutableObject<IState>, action: any) => {
      return store.set('invitationLoading', false);
    },
    [actions.SEND_SUPPLIER_AGENT_INVITATION_ERROR]: (store: ImmutableObject<IState>, action: any) => {
      return store.set('invitationLoading', false).set('invitationError', action.payload);
    },
  }),
  INITIAL_STATE
);
